import React, { useState, useEffect } from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead-for-bs3';
import { createQueryString } from '../../../utilities/utilities';
import { ConfigurationProps } from './types';

import 'react-bootstrap-typeahead-for-bs3/css/Typeahead.css';
import './generic_typeahead.scss';

const Autocomplete = (props: ConfigurationProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);

  const onSearch = (userQuery = '') => {
    if (props.onlySearchOnMount && results.length) return;
    setIsLoading(true);
    fetch(
      props.apiPath +
        createQueryString({ ...props.filter, q: userQuery }, props.arrayFormat)
    )
      .then((res) => res.json())
      .then((json) => {
        setResults(json[props.dataResponse]);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const onChange = (event) => {
    if (props.multiple) {
      return props.onSelect(event);
    }

    const isValid = event.length;
    props.onSelect(isValid ? event[0] : undefined);
  };

  useEffect(() => {
    if (props.searchOnMount || props.onlySearchOnMount) {
      onSearch();
    }
  }, []);

  const config = {
    onSearch,
    onChange,
    isLoading,
    options: results,
    clearButton: true,
    highlightOnlyResult: true,
    caseSensitive: false,
    placeholder: 'Enter search',
    labelKey: 'text',
    useCache: false,
    ...props,
  };

  return <AsyncTypeahead {...config} />;
};

Autocomplete.defaultProps = {
  filter: {},
  minLength: 0,
  searchOnMount: false,
  onlySearchOnMount: false,
  dataResponse: 'data',
  arrayFormat: 'brackets',
};

export default Autocomplete;
